import { User } from '../../types/user'
import { LeasingContext } from '../../types/leasingContext'
import { UserActionTypes, SET_ROOT_USER, SET_LEASE_ID, SET_LEASING_CONTEXT } from './types'

export interface UserState {
    rootUser?: User
    leaseId?: number
    leasingContext?: LeasingContext | null
}

const initialState: UserState = {
    rootUser: undefined,
    leaseId: undefined,
    leasingContext: undefined,
}

export const userReducer = (
    state = initialState,
    action: UserActionTypes,
): UserState => {
    switch (action.type) {
        case SET_ROOT_USER:
            return {
                ...state,
                rootUser: action.user,
            }
        case SET_LEASE_ID:
            return {
                ...state,
                leaseId: action.leaseId,
            }
        case SET_LEASING_CONTEXT:
            return {
                ...state,
                leasingContext: action.leasingContext,
            }
        default:
            return state
    }
}
